import { types, actions } from './requests'
export const DELETELISTING_TYPES = {
    ...types('DELETELISTING'),
}
export const DELETELISTING_ACTIONS = {
    ...actions('DELETELISTING'),
}